import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Projeler from './Projeler';
import DaireTipleri from './DaireTipleri';
import Katlar from './Katlar';
import Cepheler from './Cepheler';
import Manzaralar from './Manzaralar';
import ParaBirimleri from './ParaBirimleri';
import Kasalar from './Kasalar';
import FinansKategorileri from './FinansKategorileri';
import CariAltKategorileri from './CariAltKategorileri';
import BankaKredileri from './BankaKredileri';
import EnflasyonOranlari from './EnflasyonOranlari';
import KullaniciYonetimi from './KullaniciYonetimi';
import KurumsalBilgiler from './KurumsalBilgiler';
import DokumanSablonlari from './DokumanSablonlari';
import IslemKayitlari from './IslemKayitlari';
import LeadStatusAyarlari from './LeadStatusAyarlari';
import LeadApiAyarlariPage from './LeadApiAyarlari';
import GunSonuRaporu from './GunSonuRaporu';
import OdemePlanSablonlari from './OdemePlanSablonlari';
import Etiketler from './Etiketler';
import SmsAyarlariPage from './SmsAyarlari';
import SmsSablonlariPage from './SmsSablonlari';
import IysAktarimAyarlariPage from './IysAktarimAyarlari';

interface AyarItem {
    baslik: string;
    aciklama: string;
    icon: string;
    yol: string;
    component: React.FC;
}

interface AyarGrubu {
    baslik: string;
    icon: string;
    aciklama: string;
    renkSinifi: 'turuncu' | 'lacivert' | 'yesil';
    ogeler: AyarItem[];
}

const Ayarlar: React.FC = () => {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState(0);
    const [activeItem, setActiveItem] = useState(0);

    const gruplar: AyarGrubu[] = [
        {
            baslik: 'Proje Tanımlamaları',
            icon: 'fas fa-drafting-compass',
            aciklama: 'Projeler, daire tipleri, katlar, cepheler ve manzara tanımlamaları',
            renkSinifi: 'turuncu',
            ogeler: [
                { baslik: 'Projeler', aciklama: 'Proje listesi ve yönetimi', icon: 'fas fa-building', yol: '/projeler', component: Projeler },
                { baslik: 'Daire Tipleri', aciklama: 'Daire tip tanımlamaları', icon: 'fas fa-door-closed', yol: '/tanimlamalar/daire-tipleri', component: DaireTipleri },
                { baslik: 'Katlar', aciklama: 'Kat tanımlamaları', icon: 'fas fa-layer-group', yol: '/tanimlamalar/katlar', component: Katlar },
                { baslik: 'Cepheler', aciklama: 'Cephe yön tanımlamaları', icon: 'fas fa-compass', yol: '/tanimlamalar/cepheler', component: Cepheler },
                { baslik: 'Manzaralar', aciklama: 'Manzara tanımlamaları', icon: 'fas fa-mountain', yol: '/tanimlamalar/manzaralar', component: Manzaralar },
            ],
        },
        {
            baslik: 'Finansal Tanımlamalar',
            icon: 'fas fa-coins',
            aciklama: 'Para birimleri, kasalar, gelir/gider kategorileri ve banka tanımlamaları',
            renkSinifi: 'lacivert',
            ogeler: [
                { baslik: 'Para Birimleri', aciklama: 'Kullanılan para birimleri', icon: 'fas fa-money-bill-wave', yol: '/tanimlamalar/para-birimleri', component: ParaBirimleri },
                { baslik: 'Kasalar', aciklama: 'Kasa hesapları', icon: 'fas fa-cash-register', yol: '/tanimlamalar/kasalar', component: Kasalar },
                { baslik: 'Gelir/Gider Kategorileri', aciklama: 'Finansal işlem kategorileri', icon: 'fas fa-tags', yol: '/tanimlamalar/finans-kategorileri', component: FinansKategorileri },
                { baslik: 'Cari Alt Kategorileri', aciklama: 'Cari hesap alt grupları', icon: 'fas fa-sitemap', yol: '/tanimlamalar/cari-alt-kategorileri', component: CariAltKategorileri },
                { baslik: 'Banka Kredileri', aciklama: 'Banka kredi tanımlamaları', icon: 'fas fa-university', yol: '/tanimlamalar/banka-kredileri', component: BankaKredileri },
                { baslik: 'Enflasyon Oranları', aciklama: 'TÜFE / Yİ-ÜFE — kira artış referansı', icon: 'fas fa-chart-line', yol: '/tanimlamalar/enflasyon-oranlari', component: EnflasyonOranlari },
            ],
        },
        {
            baslik: 'Sistem Ayarları',
            icon: 'fas fa-cog',
            aciklama: 'Kullanıcı yönetimi, kurumsal bilgiler ve döküman şablonları',
            renkSinifi: 'yesil',
            ogeler: [
                ...(user?.kullaniciRolu === 'Admin'
                    ? [{ baslik: 'Kullanıcı Yönetimi', aciklama: 'Kullanıcı hesapları ve roller', icon: 'fas fa-users-cog', yol: '/tanimlamalar/kullanici-yonetimi', component: KullaniciYonetimi as React.FC }]
                    : []),
                { baslik: 'Kurumsal Bilgiler', aciklama: 'Firma adı, logo ve iletişim', icon: 'fas fa-id-card', yol: '/tanimlamalar/kurumsal-bilgiler', component: KurumsalBilgiler },
                { baslik: 'Döküman Şablonları', aciklama: 'PDF ve belge şablonları', icon: 'fas fa-file-alt', yol: '/tanimlamalar/dokuman-sablonlari', component: DokumanSablonlari },
                { baslik: 'İşlem Kayıtları', aciklama: 'Sistem işlem geçmişi', icon: 'fas fa-history', yol: '/islem-kayitlari', component: IslemKayitlari },
                { baslik: 'Gün Sonu Raporu', aciklama: 'Otomatik e-posta rapor ayarları', icon: 'fas fa-envelope-open-text', yol: '/tanimlamalar/gun-sonu-raporu', component: GunSonuRaporu },
                { baslik: 'Ödeme Planı Şablonları', aciklama: 'Daire satışı için peşinat ve taksit kuralları', icon: 'fas fa-file-invoice-dollar', yol: '/tanimlamalar/odeme-plan-sablonlari', component: OdemePlanSablonlari as React.FC },
                { baslik: 'Etiketler', aciklama: 'Kayıtlara atanabilecek etiket tanımlamaları', icon: 'fas fa-tags', yol: '/tanimlamalar/etiketler', component: Etiketler },
                { baslik: 'SMS Ayarları', aciklama: 'SMS gönderim servisi ve borç hatırlatma ayarları', icon: 'fas fa-sms', yol: '/tanimlamalar/sms-ayarlari', component: SmsAyarlariPage },
                { baslik: 'SMS Şablonları', aciklama: 'Hazır ve özel SMS mesaj şablonları', icon: 'fas fa-comment-alt', yol: '/tanimlamalar/sms-sablonlari', component: SmsSablonlariPage },
                { baslik: 'İYS Aktarım Ayarları', aciklama: 'NetGSM üzerinden İYS izni aktarım ayarları', icon: 'fas fa-share-alt', yol: '/tanimlamalar/iys-aktarim-ayarlari', component: IysAktarimAyarlariPage },
            ],
        },
        {
            baslik: 'Potansiyel Müşteri Ayarları',
            icon: 'fas fa-user-tag',
            aciklama: 'Potansiyel müşteri durum tanımlamaları ve takip ayarları',
            renkSinifi: 'turuncu',
            ogeler: [
                { baslik: 'Lead Durumları', aciklama: 'Durum tanımlamaları, kanban ve liste ayarları', icon: 'fas fa-flag', yol: '/tanimlamalar/lead-durumlari', component: LeadStatusAyarlari },
                { baslik: 'Dış Kaynak API', aciklama: 'Web sitesi ve form entegrasyonu için API yönetimi', icon: 'fas fa-plug', yol: '/tanimlamalar/lead-api', component: LeadApiAyarlariPage as React.FC },
            ],
        },
    ];

    const activeGrup = gruplar[activeTab];
    const selectedOge = activeGrup.ogeler[activeItem] ?? activeGrup.ogeler[0];

    const handleTabChange = (i: number) => {
        setActiveTab(i);
        setActiveItem(0);
    };

    return (
        <div style={{ padding: '28px 32px', background: '#f4f6fb', minHeight: '100vh', fontFamily: "'Inter','Segoe UI',sans-serif" }}>
            {/* Sayfa başlığı */}
            <div style={{ marginBottom: 24 }}>
                <h1 style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', margin: 0, letterSpacing: '-0.02em' }}>Ayarlar</h1>
                <p style={{ fontSize: 13.5, color: '#64748b', margin: '4px 0 0' }}>Sistem tanımlamaları, kullanıcı yönetimi ve yapılandırma ayarları</p>
            </div>

            {/* Ana Kart */}
            <div style={{
                background: '#fff',
                borderRadius: 14,
                border: '1px solid #e5e7eb',
                boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
                overflow: 'hidden',
            }}>
                {/* Sekme Başlıkları */}
                <div style={{
                    borderBottom: '1px solid #e5e7eb',
                    padding: '0 24px',
                    display: 'flex',
                    flexWrap: 'wrap',
                }}>
                    {gruplar.map((g, i) => {
                        const isActive = i === activeTab;
                        return (
                            <button
                                key={g.baslik}
                                onClick={() => handleTabChange(i)}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '14px 18px',
                                    border: 'none',
                                    borderBottom: isActive ? '2px solid #cd6906' : '2px solid transparent',
                                    background: 'none',
                                    cursor: 'pointer',
                                    fontSize: 13.5,
                                    fontWeight: isActive ? 600 : 500,
                                    color: isActive ? '#cd6906' : '#4b5563',
                                    transition: 'all 0.15s',
                                    whiteSpace: 'nowrap',
                                    marginBottom: -1,
                                }}
                                onMouseEnter={e => { if (!isActive) e.currentTarget.style.color = '#111827'; }}
                                onMouseLeave={e => { if (!isActive) e.currentTarget.style.color = '#4b5563'; }}
                            >
                                <i className={g.icon} style={{ fontSize: 13, opacity: isActive ? 1 : 0.7 }}></i>
                                {g.baslik}
                                <span style={{
                                    background: isActive ? 'rgba(205,105,6,0.12)' : '#f3f4f6',
                                    color: isActive ? '#cd6906' : '#6b7280',
                                    borderRadius: 20,
                                    padding: '1px 8px',
                                    fontSize: 11,
                                    fontWeight: 600,
                                }}>
                                    {g.ogeler.length}
                                </span>
                            </button>
                        );
                    })}
                </div>

                {/* İki Kolonlu İçerik */}
                <div style={{ display: 'flex', minHeight: 420 }}>
                    {/* Sol Menü */}
                    <div style={{
                        width: 240,
                        borderRight: '1px solid #e5e7eb',
                        flexShrink: 0,
                        padding: '12px 8px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                    }}>
                        <div style={{ padding: '6px 12px 10px', fontSize: 11, fontWeight: 600, color: '#9ca3af', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
                            {activeGrup.baslik}
                        </div>
                        {activeGrup.ogeler.map((oge, i) => {
                            const isSelected = i === activeItem;
                            return (
                                <button
                                    key={oge.yol}
                                    onClick={() => setActiveItem(i)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                        padding: '10px 12px',
                                        borderRadius: 8,
                                        border: 'none',
                                        background: isSelected ? 'rgba(205,105,6,0.08)' : 'none',
                                        color: isSelected ? '#cd6906' : '#374151',
                                        fontSize: 13,
                                        fontWeight: isSelected ? 600 : 500,
                                        cursor: 'pointer',
                                        textAlign: 'left',
                                        width: '100%',
                                        transition: 'all 0.15s',
                                    }}
                                    onMouseEnter={e => { if (!isSelected) { e.currentTarget.style.background = '#f9fafb'; e.currentTarget.style.color = '#111827'; } }}
                                    onMouseLeave={e => { if (!isSelected) { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#374151'; } }}
                                >
                                    <span style={{
                                        width: 30, height: 30, borderRadius: 7,
                                        background: isSelected ? 'rgba(205,105,6,0.12)' : '#f3f4f6',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        flexShrink: 0, transition: 'all 0.15s',
                                    }}>
                                        <i className={oge.icon} style={{ fontSize: 13, color: isSelected ? '#cd6906' : '#6b7280' }}></i>
                                    </span>
                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{oge.baslik}</span>
                                    {isSelected && (
                                        <i className="fas fa-chevron-right" style={{ marginLeft: 'auto', fontSize: 10, color: '#cd6906', flexShrink: 0 }}></i>
                                    )}
                                </button>
                            );
                        })}
                    </div>

                    {/* Sağ Panel - Component direkt render */}
                    <div style={{ flex: 1, overflow: 'auto', minWidth: 0 }}>
                        {selectedOge && (() => {
                            const SelectedComponent = selectedOge.component;
                            return <SelectedComponent />;
                        })()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ayarlar;
